import 'react-app-polyfill/stable'
import './index.css'
import './designSystem.css'
import './env'

import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { clearStaleChunkGuard, installStaleChunkReload } from './lib/staleChunkReload'

// Before the first render: a deploy can land between boot and the first lazy
// route, and the listener has to be in place when that route asks for a chunk
// the running build's manifest no longer matches.
installStaleChunkReload()

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// We got here, so the module graph this tab holds is servable. Release the
// one-reload guard for the next deploy.
clearStaleChunkGuard()
